import { useMemo } from 'react';

import { useEmbedBootstrap } from '../use-widget-bootstrap';
import { buildBranchLabelCases, type BranchLabelCases } from '../widget-lib/ru-branch-label-cases';

const DEFAULT_PLURAL = 'Салоны';
const DEFAULT_SINGULAR = 'Салон';

/**
 * Подписи филиалов в UI: `GET /public/widget` → `branch_label_*`, витрина — из `organizations-with-branches`.
 * Иначе «Салоны» / «Салон». Плюс формы для типовых фраз (род./дат. мн. и род. ед.).
 */
export function useBranchLabels(): BranchLabelCases {
  const { widgetConfig, guestShowcaseOrg } = useEmbedBootstrap();

  return useMemo(() => {
    let plural =
      (widgetConfig?.branch_label_plural ?? '').trim() ||
      (guestShowcaseOrg?.branch_label_plural ?? '').trim() ||
      DEFAULT_PLURAL;
    const singular =
      (widgetConfig?.branch_label_singular ?? '').trim() ||
      (guestShowcaseOrg?.branch_label_singular ?? '').trim() ||
      DEFAULT_SINGULAR;
    
    if (plural.toLowerCase() === 'филиалов') {
      plural = 'Филиалы';
    }
    
    return buildBranchLabelCases(plural, singular);
  }, [widgetConfig, guestShowcaseOrg]);
}
